import ES from './es';
import EN from './en';

const menu = {
    ES,
    EN
};

export default menu;
